"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Team = /*#__PURE__*/function () {
  function Team(client) {
    (0, _classCallCheck2["default"])(this, Team);
    this.client = client;
    this.resourceUrl = '/team';
  }

  (0, _createClass2["default"])(Team, [{
    key: "getTeamList",
    value: function getTeamList(parmas) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "?tab=myclient").concat(parmas), args);
    }
  }]);
  return Team;
}();

exports["default"] = Team;